export default __webpack_public_path__ + "static/media/nooffers.004ac357.png";